import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";

//调入调出监测
export default () => {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}